import axiosClient from './axiosClient';
import { apiPath } from '../../utils/api-contants';

const profile = {
  fetchUserPofileData: async (payload: any) => {
    try {
      const apiResponse: any = await axiosClient.get(apiPath.USER_SERVICE_BASE_URL + '/users/' + payload);
      const res: any = apiResponse.data;
      
      return {
        status: 'success',
        code: apiResponse?.status,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchPassword: async (payload: any) => {
    try {
      const apiResponse: any = await axiosClient.get(
        apiPath.USER_SERVICE_BASE_URL +
          '/users/' +
          'reset-password?email=' +
          payload.email +
          '&current_password=' +
          payload.password
      );
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  updatePassword: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.put(apiPath.USER_SERVICE_BASE_URL + '/users/change-password', payload);
      return {
        status: 'success',
        code: apiResponse?.status,
        data: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
};

export default profile;
